import { createFileRoute, redirect } from '@tanstack/react-router'
import { BudgetGridScreen } from '@/features/accounting-budgets/budget-grid-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating a budget.
 *
 * The grant guard is presentation only. The API enforces
 * `accounting_budget.create` on POST /accounting/budgets, so a stale grant
 * still 403s server-side; this keeps a user without it out of a screen they
 * cannot use.
 */
export const Route = createFileRoute('/_authenticated/accounting/budgets/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_budget.create')) {
      throw redirect({ to: '/accounting/budgets' })
    }
  },
  component: BudgetGridScreen,
})
